import React, { useEffect, useState } from 'react';
import { Menu } from './Menu';
import { ContentSelector } from './ContentSelector';
import { NavigationBar } from './NavigationBar';
import { useSidebarVisibility, useWithSidebarVisibility } from 'services/useSidebarVisibility';
import { useWithSelectedMenu } from 'services/useSelectedMenu';
import { ThreePanesWithShrinkableSidebar } from 'components/views/molecules/ThreePanesWithShrinkableSidebar';
import { useWithProjects } from 'services/useProjects';
import { useWithSelectedProject, useSelectedProject } from 'services/useSelectedProject';
import { useWithEnvironments, useEnvironments } from 'services/useEnvironments';
import { useWithScope, useUpdateScope } from 'services/useScope';
import { useWithSelectedEnvironment, useSelectedEnvironment } from 'services/useSelectedEnvironment';
import { useMultiScreenSupport } from './useMultiScreenSupport';
import { useWithNavbarVisibility, useNavbarVisibility } from 'services/useNavbarVisibility';
import { useOIDCClient } from 'services/oidc';
import { withAdaptors } from 'services/utility/withAdaptors';
import { ErrorBoundary } from 'react-error-boundary';

const Wrapper = (props: { rootPath: string }) => {
    const sidebarVisible = useSidebarVisibility();
    const navbarVisible = useNavbarVisibility();

    const [navbarShouldVisible, setNavbarShouldVisible] = useState(true);
    function onMouseMove(event: React.MouseEvent<HTMLDivElement>) {
        setNavbarShouldVisible(event.clientY < 30);
    }
    useEffect(() => {
        setNavbarShouldVisible(sidebarVisible);
    }, [sidebarVisible, setNavbarShouldVisible]);

    const [navbarIsInUse, setNavbarIsInUse] = useState(false);

    useMultiScreenSupport(props.rootPath);

    const projectId = useSelectedProject()?.id;
    const environments = useEnvironments(projectId);
    const environmentId = useSelectedEnvironment(environments)?.id;

    useUpdateScope(projectId, environmentId);

    return (
        <div onMouseMove={onMouseMove}>
            <ThreePanesWithShrinkableSidebar sidebarVisible={sidebarVisible} navbarVisible={sidebarVisible || navbarIsInUse || navbarShouldVisible || navbarVisible}>
                <ErrorBoundary fallbackRender={props => {
                    console.info(props);
                    return <div>no way</div>;
                }}>
                    <div onMouseEnter={() => setNavbarIsInUse(true)} onMouseLeave={() => setNavbarIsInUse(false)}>
                        <NavigationBar />
                    </div>
                </ErrorBoundary>
                <Menu />
                <ContentSelector />
            </ThreePanesWithShrinkableSidebar>
        </div>
    );
};

export const ConsolePage = (props: { rootPath: string }) => {
    const withSidebarVisibility = useWithSidebarVisibility();
    const withNavbarVisibility = useWithNavbarVisibility();
    const withSelectedMenu = useWithSelectedMenu();
    const withProjects = useWithProjects();
    const withSelectedProject = useWithSelectedProject();
    const withEnvironments = useWithEnvironments();
    const withSelectedEnvironment = useWithSelectedEnvironment();
    const withScopes = useWithScope();

    const oidcClient = useOIDCClient();
    useEffect(() => {
        if (!oidcClient) return;
        oidcClient.enableAutoRefresh();
    }, [oidcClient]);

    return withAdaptors(
        withProjects,
        withSelectedProject,
        withEnvironments,
        withSelectedEnvironment,
        withScopes,
        withSelectedMenu,
        withSidebarVisibility,
        withNavbarVisibility
    )(
        <Wrapper {...props} />
    );
};
